import { render, staticRenderFns } from "./IncludedBlock.vue?vue&type=template&id=d77f2566&"
import script from "./IncludedBlock.vue?vue&type=script&setup=true&lang=js&"
export * from "./IncludedBlock.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./IncludedBlock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports